import { render, staticRenderFns } from "./NestStatistic.vue?vue&type=template&id=1ef44620"
import script from "./NestStatistic.vue?vue&type=script&lang=js"
export * from "./NestStatistic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports